// Third party CSS
import 'keen-slider/keen-slider.min.css'

// Global styles
import '../styles/Font.css'
import '../styles/Animation.css'
